import { styled, Theme } from '@nexelem/deprecated-theme';

export const StyledContainer = styled('div')(({ theme }) => {
  const typedTheme = theme as Theme;
  const { elevation } = typedTheme.palette;
  return {
    ...elevation.tiny,
    display: 'flex',
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: 10,
    maxWidth: '400px',
    width: '100%',
    opacity: 0,
    backgroundColor: '#fff',
    borderRadius: theme.spacing(2),
    transition: 'opacity 0.5',
  };
});

export const StyledInput = styled('input')(({ theme }) => {
  const typedTheme = theme as Theme;
  const {
    palette: { getColor },
  } = typedTheme;
  const { inputBackgroundColor, borderColor } = typedTheme.client.richTextField.floatingLink;
  return {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    border: `1px solid ${getColor(borderColor)}`,
    background: getColor(inputBackgroundColor),
    outline: '0',
    position: 'relative',
  };
});

type StyledLinkViewProps = {
  readonly isEdit?: boolean;
};

export const StyledLinkView = styled('div')<StyledLinkViewProps>(({ theme, isEdit }) => {
  const typedTheme = theme as Theme;
  return {
    width: 'calc(100% - 24px)',
    margin: typedTheme.spacing(0.5, 0, 0.5, 4),
    borderRadius: typedTheme.spacing(2),
    position: 'relative',
    fontFamily: 'inherit',
    a: {
      display: 'block',
      wordBreak: 'break-word',
      width: '100%',
      color: '#229B70',
    },
  };
});

export const StyledLinkEditView = styled(StyledLinkView)<StyledLinkViewProps>(({ theme, isEdit }) => {
  const typedTheme = theme as Theme;
  return {
    margin: typedTheme.spacing(0.5, 0, 0.5, 2),
  };
});
